export default __webpack_public_path__ + "static/home-menu-e1ef27648e08db81a8a8c84f30173130.jpg";